import React from 'react';
import Table from '../../table/Table';
import { generateId } from '../../utility/functions';
import Button from '../../forms/Button';
import PageBreak from '../../layout/PageBreak';
import FormSetting from '../../layout/FormSetting';
import Input from '../../forms/Input';
import Preput from '../../forms/Preput';
import Checkbox from '../../forms/Checkbox';
import Select from '../../forms/Select';
import TextArea from '../../forms/TextArea';
import { QuestRoute } from '../../api/QuestRoutes';
import GetState from '../../GetState';
import TerminalIDsSelector from '../../forms/formComponents/TerminalIDsSelector';
import LocationSelectors from '../../forms/formComponents/LocationSelectors';
import AutoSelectAndUpgrade from '../../forms/formComponents/AutoSelectAndUpgrade';
import HamQuest from '../../api/HamQuestGiver';
import Form from '../../forms/Form';
import Radio from '../../forms/Radio';
import Heading from '../../forms/Heading';
import ColorInput from '../../forms/formComponents/ColorInput';
import ImageIndex from '../../forms/formComponents/ImageIndex';
import ManagementRow from '../../table/ManagementRow';
import ModalFactory from '../../Modal';

const BirthdayClub = ({ ...props }) => {
    const [awards, refreshAwards] = GetState(QuestRoute.birthday.awards, { loading: [] });

    const deleteRefAward = (ref) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: `Are you sure you want to delete ${ref.name}?`,
                type: 'warning',
            },
            promise: {
                title: 'Deleting Referral',
                body: `Deleting ${ref.name}`,
                callback: () => HamQuest.delete(QuestRoute.birthday.edit(ref.awardId))
            },
            confirmed: {
                title: 'Success',
                body: `${ref.name} successfully deleted.`,
                type: 'success'
            },
            finally: () => refreshAwards()
        })
    }

    const editRefAward = (ref) => {
        // console.log(ref)
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Edit ${ref.name}`,
            body: (
                <Form
                    inputs={{ ...ref }}
                    onSubmit={e => HamQuest.put(QuestRoute.birthday.edit(e.awardId), { ...e })
                        .then(() => {
                            refreshAwards();
                            ModalFactory.close(id);
                        })
                    }
                    text='Update'
                >
                    {({ values }) =>
                        <>
                            <Input
                                label='Name'
                                name='name'
                                required
                            />
                            <Preput
                                label='Description'
                                name='description'
                            />
                            <Input
                                label='SKU'
                                name='sku'
                            />
                            <Radio
                                label='Item'
                                name='kioskItemId'
                                getOptions={QuestRoute.kiosks.wash}
                                buildOptions={e => {
                                    e.label = e.name
                                    e.value = e.id
                                }}
                                required
                            />
                            <Input
                                label='Expires'
                                name='expires'
                                type='number'
                            />

                            <AutoSelectAndUpgrade
                                upgrades='allowUpgrades'
                                select='autoSelectItem'
                            />
                            <LocationSelectors />
                            <TerminalIDsSelector />
                        </>
                    }
                </Form>
            )
        })
    }

    const addNewRefAward = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Add a new Birthday Award`,
            body: (
                <Form
                    inputs={{
                        name: '',
                        description: '',
                        sku: '',
                        kioskItemId: '',
                        expires: '',
                        allowUpgrades: '',
                        autoSelectItem: '',
                        locations: [],
                        terminalIds: [],
                    }}
                    onSubmit={e => HamQuest.post(QuestRoute.birthday.awards, { ...e })
                        .then(() => {
                            refreshAwards();
                            ModalFactory.close(id);
                        })
                    }
                    text='Update'
                >
                    {({ values }) =>

                        <>
                            <Input
                                label='Name'
                                name='name'
                                required
                            />
                            <Preput
                                label='Description'
                                name='description'
                            />
                            <Input
                                label='SKU'
                                name='sku'
                            />
                            <Radio
                                label='Item'
                                name='kioskItemId'
                                getOptions={QuestRoute.kiosks.wash}
                                buildOptions={e => {
                                    e.label = e.name
                                    e.value = e.id
                                }}
                                required
                            />

                            <Input
                                label='Expires'
                                name='expires'
                                type='number'
                            />

                            <AutoSelectAndUpgrade
                                upgrades='allowUpgrades'
                                select='autoSelectItem'
                            />

                            <LocationSelectors />

                            <TerminalIDsSelector />
                        </>
                    }
                </Form>
            )
        })
    }



    return (
        <PageBreak>

            <Table
                config={{
                    label: 'Birthday Club Awards',
                    controls: [<Button onClick={addNewRefAward}>Add New Birthday Award</Button>],
                    data: awards,
                    headers: [
                        {
                            label: 'Name',
                            propKey: 'name',
                        }, {
                            label: 'Description',
                            propKey: 'description ',
                        }, {
                            label: 'SKU',
                            propKey: 'sku',
                        }, {
                            label: 'Item',
                            propKey: 'kioskItemName',
                            options: true
                        },
                    ],
                    renderFormat: (e) => (
                        <ManagementRow
                            key={generateId()}
                            controls={[
                                <Button key={generateId()} onClick={() => editRefAward(e)}>Edit</Button>,
                                <Button key={generateId()} onClick={() => deleteRefAward(e)}>Delete</Button>
                            ]}
                        >
                            <td>{e.name}</td>
                            <td>{e.description}</td>
                            <td>{e.sku}</td>
                            <td>{e.kioskItemName}</td>
                        </ManagementRow>
                    )
                }}
            />

            <FormSetting
                name='birthdayClubSettings'
                label='Birthday Club Settings'
                getInputs={QuestRoute.birthday.settings}
                onSubmit={e => HamQuest.put(QuestRoute.birthday.settings, { ...e })}
                // controls={[<Button onClick={addNewRefAward}>Add New Birthday Award</Button>]}
                editable
            >
                <PageBreak>



                    <>
                        <Heading>Settings</Heading>
                        <Checkbox
                            label='Enabled'
                            name='enableBirthdayClubs'
                        />
                        <Select
                            label='Recipient Award'
                            name='awardId'
                            // getOptions={QuestRoute.birthday.awards}
                            // buildOptions={e => {
                            //     e.value = e.awardId
                            //     e.label = e.name
                            // }}
                            options={awards.map(e => ({
                                value: e.awardId,
                                label: e.name
                            }))}
                            required
                        />
                        <ColorInput
                            name='logoRGB'
                            required
                        />

                        <ImageIndex colorName='logoRGB' required />

                    </>

                    <>
                        <Heading>Birthday Club Notifications</Heading>
                        <Input
                            label='Title'
                            name='notificationSubject'
                            required
                        />
                        <Preput
                            label='Body'
                            name='notificationBody'
                            tags={['FirstName', 'LastName', 'FullName', 'KioskItemName']}
                            required
                        />
                    </>

                    <>
                        <Heading>Birthday Club Email</Heading>
                        <Checkbox
                            label='Enabled'
                            name='emailsEnabled'
                        />
                        <Input
                            label='Subject'
                            name='emailSubject'
                            required
                        />
                        <Preput
                            label='Body'
                            name='emailBody'
                            tags={['FirstName', 'LastName', 'FullName', 'KioskItemName']}
                            required
                        />
                    </>

                </PageBreak>

            </FormSetting>

        </PageBreak>
    );
}

export default BirthdayClub;